export default __webpack_public_path__ + "static/partner-bottom-bg-bc7829389ed0c26dbe9cc6b876441fc6.svg";